export enum DealerSetupStatuses_Enum {
    Approved = 1,
    Suspended = 2,
    Declined = 3,
    SetupInProgress = 4,
    OneOffDeal = 5,
    Tentative = 6,
    ApprovedDCIOnly = 7,
    OnHold = 8
}